import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const PreLogoutPage = () => {
  const { logout } = useContext(AuthContext);
  const history = useHistory();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      // Usamos window.location para forzar una recarga completa
      window.location.href = '/';
    } catch (error) {
      console.error('Error during logout:', error);
      setIsLoggingOut(false);
    }
  };

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <div className="min-height-100vh has-background-light">
      {/* Overlay de fondo */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
          zIndex: 1
        }}
      ></div>

      {/* Contenido Principal */}
      <div className="hero is-fullheight" style={{ position: 'relative', zIndex: 2 }}>
        <div className="hero-body">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-5-desktop is-6-tablet is-10-mobile">
                {/* Card Principal */}
                <div 
                  className="box has-text-centered"
                  style={{
                    borderRadius: '16px',
                    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                    background: 'rgba(255, 255, 255, 0.98)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    animation: 'fadeInUp 0.6s ease-out'
                  }}
                >
                  {/* Icono Principal */}
                  <div className="mb-5">
                    <span 
                      className="icon is-large"
                      style={{
                        fontSize: '4rem',
                        color: '#ff6b35',
                        animation: 'pulse 2s infinite'
                      }}
                    >
                      <i className="fas fa-sign-out-alt"></i>
                    </span>
                  </div>

                  {/* Título y Descripción */}
                  <h1 className="title is-4 has-text-grey-dark mb-3">
                    ¿Estás seguro que deseas salir?
                  </h1>
                  <p className="subtitle is-6 has-text-grey mb-5">
                    Estás a punto de cerrar sesión en
                    <strong className="has-text-primary ml-1">Portal Afiliados</strong>
                  </p>

                  {/* Información Adicional */}
                  <div className="notification is-warning is-light mb-5">
                    <div className="content">
                      <span className="icon-text">
                        <span className="icon mr-2">
                          <i className="fas fa-info-circle"></i>
                        </span>
                        <span className="has-text-weight-semibold">Información importante:</span>
                      </span>
                      <ul className="mt-2 mb-0">
                        <li>Tu sesión actual se cerrará completamente</li>
                        <li>Necesitarás ingresar tus credenciales nuevamente</li>
                        <li>Cualquier trabajo no guardado se perderá</li>
                      </ul>
                    </div>
                  </div>

                  {/* Botones de Acción */}
                  <div className="field is-grouped is-grouped-centered">
                    <div className="control">
                      <button
                        className={`button is-danger is-medium has-text-weight-semibold ${
                          isLoggingOut ? 'is-loading' : ''
                        }`}
                        onClick={handleLogout}
                        disabled={isLoggingOut}
                        style={{
                          borderRadius: '8px',
                          minWidth: '120px',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                          if (!isLoggingOut) {
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 6px 16px rgba(255, 107, 53, 0.4)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isLoggingOut) {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 12px rgba(255, 107, 53, 0.3)';
                          }
                        }}
                      >
                        {!isLoggingOut && (
                          <span className="icon mr-2">
                            <i className="fas fa-sign-out-alt"></i>
                          </span>
                        )}
                        <span>{isLoggingOut ? 'Cerrando Sesión...' : 'Cerrar Sesión'}</span>
                      </button>
                    </div>
                    <div className="control">
                      <button
                        className="button is-primary is-medium has-text-weight-semibold"
                        onClick={handleCancel}
                        disabled={isLoggingOut}
                        style={{
                          borderRadius: '8px',
                          minWidth: '120px',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          border: 'none',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                          if (!isLoggingOut) {
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isLoggingOut) {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                          }
                        }}
                      >
                        <span className="icon mr-2">
                          <i className="fas fa-arrow-left"></i>
                        </span>
                        <span>Permanecer</span>
                      </button>
                    </div>
                  </div>

                  {/* Footer con Consejos */}
                  <div className="has-text-centered mt-5 pt-4" style={{ borderTop: '1px solid #f5f5f5' }}>
                    <p className="is-size-7 has-text-grey">
                      <span className="icon is-small mr-1">
                        <i className="fas fa-lightbulb"></i>
                      </span>
                      <strong>Consejo:</strong> Guarda tu trabajo antes de cerrar sesión
                    </p>
                  </div>
                </div>

                {/* Información de Seguridad */}
                <div className="box mt-4" style={{ borderRadius: '12px' }}>
                  <div className="columns is-mobile">
                    <div className="column">
                      <div className="content has-text-centered">
                        <span className="icon has-text-success mb-2">
                          <i className="fas fa-shield-alt"></i>
                        </span>
                        <p className="is-size-7 has-text-weight-semibold mb-1">Seguro</p>
                        <p className="is-size-7 has-text-grey">Conexión protegida</p>
                      </div>
                    </div>
                    <div className="column">
                      <div className="content has-text-centered">
                        <span className="icon has-text-info mb-2">
                          <i className="fas fa-clock"></i>
                        </span>
                        <p className="is-size-7 has-text-weight-semibold mb-1">Automático</p>
                        <p className="is-size-7 has-text-grey">Cierre por inactividad</p>
                      </div>
                    </div>
                    <div className="column">
                      <div className="content has-text-centered">
                        <span className="icon has-text-warning mb-2">
                          <i className="fas fa-save"></i>
                        </span>
                        <p className="is-size-7 has-text-weight-semibold mb-1">Backup</p>
                        <p className="is-size-7 has-text-grey">Guarda tu progreso</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Estilos CSS adicionales */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        .min-height-100vh {
          min-height: 100vh;
        }

        .button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .button:disabled:hover {
          transform: none !important;
        }

        /* Responsive adjustments */
        @media screen and (max-width: 768px) {
          .field.is-grouped.is-grouped-centered {
            flex-direction: column;
          }
          
          .field.is-grouped.is-grouped-centered .control {
            width: 100%;
            margin-bottom: 0.75rem;
          }
          
          .field.is-grouped.is-grouped-centered .control .button {
            width: 100%;
          }
        }

        /* Mejoras de accesibilidad */
        .button:focus {
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25) !important;
        }

        .button.is-danger:focus {
          box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.25) !important;
        }
      `}</style>
    </div>
  );
};

export default PreLogoutPage;